// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"matrix_wrapper__2c6Kh","transparents":"matrix_transparents__X_saS","titleRow":"matrix_titleRow__3Ab16","openContainer":"matrix_openContainer__1xqzZ"};